(() => {
  if (document.querySelector(".template-product")) {
    document.addEventListener("DOMContentLoaded", () =>
      window.dispatchEvent(new Event("resize"))
    );

    const e = document.querySelectorAll(
        ".boost-pfs-quickview-selector-wrapper"
      ),
      t = document.querySelector(".product__select"),
      o = document.querySelector(".main-form"),
      r = document.querySelector(".product-form__submit"),
      i = document.querySelector(".minus-icon"),
      n = document.querySelector(".plus-icon"),
      a = document.querySelector("#Quantity-sub-main"),
      c = document.querySelectorAll(".product-sku .sku"),
      l = document.querySelector(".main-product__preloader");

let pageJustLoaded = true;
setTimeout(() => { pageJustLoaded = false; }, 500);

// Initial gallery setup on page load
document.addEventListener('DOMContentLoaded', () => {
  const thumbsEl = document.querySelector('.product-gallery__thumbs');
  if (thumbsEl) {
    const initThumbs = new Swiper('.product-gallery__thumbs', {
      spaceBetween: 8,
      slidesPerView: 'auto',
      direction: 'vertical',
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      breakpoints: {
        0: { direction: 'horizontal' },
        751: { direction: 'vertical' }
      }
    });
    new Swiper('.product-gallery__main', {
      spaceBetween: 8,
      slidesPerView: 1,
      thumbs: { swiper: initThumbs }
    });
  } else {
    new Swiper('.product-gallery__main', {
      spaceBetween: 8,
      slidesPerView: 1
    });
  }
});

// Re-initialize gallery after variant change updates the DOM
o.addEventListener('update-pdp-gallary', () => {
  document.querySelectorAll('.product-gallery__thumbs').forEach(el => el.swiper?.destroy(true, true));
  document.querySelectorAll('.product-gallery__main').forEach(el => el.swiper?.destroy(true, true));

  const thumbsEl = document.querySelector('.product-gallery__thumbs');
  if (thumbsEl) {
    const newThumbs = new Swiper('.product-gallery__thumbs', {
      spaceBetween: 8,
      slidesPerView: 'auto',
      direction: 'vertical',
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      breakpoints: {
        0: { direction: 'horizontal' },
        751: { direction: 'vertical' }
      }
    });
    new Swiper('.product-gallery__main', {
      spaceBetween: 8,
      slidesPerView: 1,
      thumbs: { swiper: newThumbs }
    });
  } else {
    new Swiper('.product-gallery__main', {
      spaceBetween: 8,
      slidesPerView: 1
    });
  }
});

    i.addEventListener("click", () => {
      a.value - 1 != 0 && a.setAttribute("value", a.value - 1);
    }),
      n.addEventListener("click", () => {
        parseInt(a.value) && a.setAttribute("value", parseInt(a.value) + 1);
      }),
      o.addEventListener("change", () => {
        if (pageJustLoaded) return;
        l.classList.add("active");

        const e = document.querySelector(".main-product__container"),
          r = e.dataset.section,
          i = e.dataset.url,
          n = +t.value;

        fetch(`${i}?variant=${n}&section_id=${r}`)
          .then((e) => e.text())
          .then((e) => {
            const t = new DOMParser().parseFromString(e, "text/html"),
              r = document.querySelector(".main-product__price"),
              i = t.querySelector(".main-product__price"),
              n = document.querySelector(
                '[data-option-position="1"] .option-title__value'
              ),
              a = t.querySelector(
                '[data-option-position="1"] .option-title__value'
              ),
              c = document.querySelector(
                '[data-option-position="2"] .option-title__value'
              ),
              l = t.querySelector(
                '[data-option-position="2"] .option-title__value'
              ),
              s = document.querySelector(
                '[data-option-position="3"] .option-title__value'
              ),
              d = t.querySelector(
                '[data-option-position="3"] .option-title__value'
              ),
              u = document.querySelector(".product-gallery__thumbs"),
              p = t.querySelector(".product-gallery__thumbs"),
              m = document.querySelector(".product-gallery__main"),
              v = t.querySelector(".product-gallery__main");

            i && r && (r.innerHTML = i.innerHTML),
              a && n && (n.innerHTML = a.innerHTML),
              l && c && (c.innerHTML = l.innerHTML),
              d && s && (s.innerHTML = d.innerHTML),
              u && p && (u.innerHTML = p.innerHTML),
              m && v && (m.innerHTML = v.innerHTML),
              o.dispatchEvent(new Event("update-pdp-gallary", { bubbles: !0 }));
          })
          .finally(() => {
            l.classList.remove("active");
          });
      });

    function getSelectedVariantTitle() {
      var n = "";
      
      const optionWrappers = Array.from(e).sort((a, b) => {
        const posA = parseInt(a.querySelector('[data-option-position]')?.getAttribute('data-option-position') || '0');
        const posB = parseInt(b.querySelector('[data-option-position]')?.getAttribute('data-option-position') || '0');
        return posA - posB;
      });

      optionWrappers.forEach((wrapper, index) => {
        let selectedValue = "";
        
        const dropdown = wrapper.querySelector('.product-option-select');
        if (dropdown && dropdown.value) {
          selectedValue = dropdown.value;
        } else {
          const checkedRadio = wrapper.querySelector('.boost-pfs-quickview-select-option:checked');
          if (checkedRadio) {
            selectedValue = checkedRadio.value;
          } else {
            const activeSwatch = wrapper.querySelector('.boost-pfs-swatch-element.is-active, .boost-pfs-swatch-element.selected');
            if (activeSwatch) {
              selectedValue = activeSwatch.getAttribute('data-value') || activeSwatch.getAttribute('data-handle');
            }
          }
        }

        if (selectedValue) {
          n = index == 0 ? selectedValue : `${n} / ${selectedValue}`;
        }
      });

      return n;
    }

    function updateVariantSelection() {
      const variantTitle = getSelectedVariantTitle();
      
      if (!variantTitle) return;

      let variantFound = false;
      let previousValue = t.value;
      
      Array.from(t).forEach((option) => {
        option.selected = false;
      });
      
      Array.from(t).forEach((option) => {
        if (option.dataset.title == variantTitle) {
          option.selected = true;
          variantFound = true;
          
          if (t.value != option.value) {
            t.value = option.value;
          }
          
          c.forEach((skuElement) => {
            skuElement.dataset.id != option.getAttribute("value")
              ? skuElement.classList.remove("is-show")
              : skuElement.classList.add("is-show");
          });

          if (option.disabled) {
            r.setAttribute("disabled", "");
            if (r.firstElementChild) {
              r.firstElementChild.innerText = "Sold out";
            }
          } else {
            r.removeAttribute("disabled");
            if (r.firstElementChild) {
              r.firstElementChild.innerText = "Add to cart";
            }
          }
        }
      });

      if (variantFound && t.value && t.value != previousValue) {
        setTimeout(() => {
          t.dispatchEvent(new Event("change", { bubbles: true }));
          o.dispatchEvent(new Event("change", { bubbles: true }));
        }, 10);
      }
    }

    e.forEach((wrapper) => {
      const swatches = wrapper.querySelectorAll(".boost-pfs-swatch-element");
      
      swatches.forEach((swatch, index) => {
        swatch.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          
          swatches.forEach((s, i) => {
            if (i != index) {
              s.classList.remove("is-active", "selected");
              const radio = s.querySelector('.boost-pfs-quickview-select-option');
              if (radio) {
                radio.checked = false;
              }
            } else {
              s.classList.add("is-active", "selected");
            }
          });

          const radioInput = swatch.querySelector('.boost-pfs-quickview-select-option');
          if (radioInput) {
            radioInput.checked = true;
            radioInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          const optionTitle = wrapper.querySelector('.option-title');
          const optionTitleValue = optionTitle?.querySelector('.option-title__value');
          if (optionTitleValue) {
            const selectedValue = swatch.getAttribute('data-value') || radioInput?.value;
            if (selectedValue) {
              optionTitleValue.textContent = selectedValue;
            }
          }

          updateVariantSelection();
        });
      });
    });

    e.forEach((wrapper) => {
      const dropdown = wrapper.querySelector('.product-option-select');
      if (dropdown) {
        dropdown.addEventListener("change", (event) => {
          event.stopPropagation();
          
          const optionTitle = wrapper.querySelector('.option-title');
          const optionTitleValue = optionTitle?.querySelector('.option-title__value');
          if (optionTitleValue) {
            optionTitleValue.textContent = dropdown.value;
          }

          updateVariantSelection();
        });
      }
    });

    o.addEventListener("change", (event) => {
      if (event.target.classList.contains('boost-pfs-quickview-select-option') && 
          event.target.type === 'radio') {
        const swatch = event.target.closest('.boost-pfs-swatch-element');
        if (swatch) {
          const wrapper = swatch.closest('.boost-pfs-quickview-selector-wrapper');
          if (wrapper) {
            wrapper.querySelectorAll('.boost-pfs-swatch-element').forEach(s => {
              s.classList.remove('is-active', 'selected');
              const radio = s.querySelector('.boost-pfs-quickview-select-option');
              if (radio && radio != event.target) {
                radio.checked = false;
              }
            });
            swatch.classList.add('is-active', 'selected');
          }
        }
        updateVariantSelection();
      }
    });

    Array.from(t).forEach((variantOption) => {
      if (variantOption.selected && !variantOption.disabled) {
        const variantTitleParts = variantOption.dataset.title.split(" / ");

        const optionWrappers = Array.from(e).sort((a, b) => {
          const posA = parseInt(a.querySelector('[data-option-position]')?.getAttribute('data-option-position') || '0');
          const posB = parseInt(b.querySelector('[data-option-position]')?.getAttribute('data-option-position') || '0');
          return posA - posB;
        });

        optionWrappers.forEach((wrapper, index) => {
          const optionValue = variantTitleParts[index];
          
          if (optionValue) {
            const dropdown = wrapper.querySelector('.product-option-select');
            if (dropdown) {
              dropdown.value = optionValue;
              const optionTitleValue = wrapper.querySelector('.option-title__value');
              if (optionTitleValue) {
                optionTitleValue.textContent = optionValue;
              }
            } else {
              const swatches = wrapper.querySelectorAll(".boost-pfs-swatch-element");
              swatches.forEach((swatch) => {
                const swatchValue = swatch.getAttribute("data-value");
                const radioInput = swatch.querySelector('.boost-pfs-quickview-select-option');
                const radioValue = radioInput?.value;
                
                if (swatchValue == optionValue || radioValue == optionValue) {
                  swatch.classList.add("is-active", "selected");
                  if (radioInput) {
                    radioInput.checked = true;
                  }
                  
                  const optionTitleValue = wrapper.querySelector('.option-title__value');
                  if (optionTitleValue) {
                    optionTitleValue.textContent = optionValue;
                  }
                } else {
                  swatch.classList.remove("is-active", "selected");
                  if (radioInput) {
                    radioInput.checked = false;
                  }
                }
              });
            }
          }
        });

        c.forEach((skuElement) => {
          skuElement.dataset.id != variantOption.getAttribute("value")
            ? skuElement.classList.remove("is-show")
            : skuElement.classList.add("is-show");
        });
      }
    });

    const s = document.querySelector(".main-product__accordions");

    s &&
      s.querySelectorAll(".main-product__accordion").forEach((e) => {
        e.querySelector(".title").addEventListener("click", () => {
          e.classList.toggle("active");
        });
      });
  }
})();